import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LoginScreen from './pages/login/LoginScreen';
import UsersScreen from 'pages/users/UsersScreen';
import { StyledEngineProvider } from '@mui/material/styles';
import UserDetailsScreen from 'pages/users/UserDetailsScreen';
import { Provider } from 'react-redux';
import store, { useAppDispatch, useAppSelector } from 'store/store';
import DiscountsScreen from 'pages/discounts/DiscountsScreen';
import UsersHelpPage from 'pages/tutorial/UsersHelpPage';
import DiscountsHelpPage from 'pages/tutorial/DiscountsHelpPage';
import CouponsHelpPage from 'pages/tutorial/CouponsHelpPage';
import reportWebVitals from 'reportWebVitals';
import React, { useEffect, useMemo } from 'react';
import {
  apiClient,
  apiSignOutController,
  tokenController,
} from 'common/client';
import { authActions } from 'store/reducers/auth';
import SMEDiscountsScreen from 'pages/sme/SMEDiscountsScreen';
import InvestorsScreen from 'pages/sme/InvestorsScreen';
import { tokenManager } from 'common/tokenManager';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8d09f7',
    },
  },
});

const App = () => {
  const loggedIn = useAppSelector((state) => state.auth.loggedIn);

  const dispatch = useAppDispatch();

  useEffect(() => {
    apiSignOutController.signOut = () => {
      tokenManager.getTokens().then(({ refreshToken }) => {
        apiClient.post('/auth/logout', { refreshToken }).finally(() => {
          tokenManager.clearTokens();
          dispatch(authActions.setLoggedIn(false));
        });
      });
    };
  }, [dispatch]);

  useEffect(() => {
    tokenController.getAccessToken = tokenManager.getTokens;
  }, []);

  useEffect(() => {
    tokenManager
      .getTokens()
      .then(() => {
        dispatch(authActions.setLoggedIn(true));
      })
      .catch(() => {
        dispatch(authActions.setLoggedIn(false));
      });
  }, [dispatch]);

  const loggedOutRouter = useMemo(() => {
    return createBrowserRouter([{ path: '/*', element: <LoginScreen /> }]);
  }, []);

  const loggedInRouter = useMemo(() => {
    return createBrowserRouter([
      { path: '/*', element: <UsersScreen /> },
      { path: '/discounts', element: <DiscountsScreen /> },
      { path: '/sme', element: <SMEDiscountsScreen /> },
      { path: '/investors', element: <InvestorsScreen /> },
      { path: '/users/:id', element: <UserDetailsScreen /> },
      { path: '/help_users', element: <UsersHelpPage /> },
      { path: '/help_discounts', element: <DiscountsHelpPage /> },
      { path: '/help_discounts_edit', element: <CouponsHelpPage /> },
    ]);
  }, []);

  if (loggedIn === undefined) {
    return null;
  }

  if (loggedIn) {
    return <RouterProvider router={loggedInRouter} />;
  }

  return <RouterProvider router={loggedOutRouter} />;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Provider>
    </StyledEngineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
